import { render, staticRenderFns } from "./android.vue?vue&type=template&id=a00f5872&"
import script from "./android.vue?vue&type=script&lang=js&"
export * from "./android.vue?vue&type=script&lang=js&"
import style0 from "./android.vue?vue&type=style&index=0&id=a00f5872&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports